if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.bar = this.querySelector('.sticky-atc');
        this.priceTarget = this.querySelector('.sticky-atc__price');
        this.button = this.querySelector('.sticky-atc__button');
        // The inline Add to cart button we watch to decide when to reveal.
        this.trigger = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        // The very bottom of the page — the copyright trust bar (fallback: the
        // footer) — once it's in view we hide the bar; until then it stays up
        // even while scrolling the footer content.
        this.footer = document.querySelector('.footer__trustbar') || document.querySelector('.footer');
        // Reveal state, combined in updateVisibility().
        this.scrolledPast = false;
        this.footerVisible = false;
      }

      connectedCallback() {
        if (!this.trigger || !this.bar) return;

        // Reveal the bar only once the inline button has scrolled ABOVE the
        // viewport — not while it's still below the fold on first paint
        // (where it's also "not intersecting", but sitting further down).
        this.observer = new IntersectionObserver(([entry]) => {
          this.scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.updateVisibility();
        });
        this.observer.observe(this.trigger);

        // Hide the bar whenever the footer is on screen.
        if (this.footer) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.footerVisible = entry.isIntersecting;
            this.updateVisibility();
          });
          this.footerObserver.observe(this.footer);
        }

        this.syncFromInline();
        // Keep price + button state in lockstep with the inline form so the
        // bar never shows a stale price or an addable sold-out variant.
        this.variantSub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId === this.sectionId) this.syncFromInline();
        });
        this.quantitySub = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.syncFromInline());
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.footerObserver?.disconnect();
        this.variantSub?.();
        this.quantitySub?.();
      }

      // Show the bar once the inline button has scrolled out of view, but never
      // while the footer is on screen.
      updateVisibility() {
        this.bar.classList.toggle('is-visible', this.scrolledPast && !this.footerVisible);
      }

      syncFromInline() {
        const livePrice = document.getElementById(`price-${this.sectionId}`);
        if (livePrice && this.priceTarget) {
          this.priceTarget.innerHTML = livePrice.innerHTML;
          // The mirrored markup carries the round Sale/Sold-out pill, which
          // doesn't fit the compact bar — the compare-at price already signals
          // the discount. Strip it so it can't wrap off the bottom edge.
          this.priceTarget
            .querySelectorAll('.price__badge-sale, .price__badge-sold-out')
            .forEach((badge) => badge.remove());
        }

        if (!this.button) return;
        const disabled = this.trigger.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);

        const label = this.trigger.querySelector('span')?.textContent.trim();
        const labelTarget = this.button.querySelector('span');
        if (label && labelTarget) labelTarget.textContent = label;
      }
    }
  );
}
